import React, { useState, useEffect } from 'react';
import '../master.css';
import { useNavigate } from 'react-router-dom';
import { FaCog, FaLayerGroup, FaMoneyBillWave, FaPizzaSlice, FaFileUpload, FaMoneyBillAlt, FaSellcast } from 'react-icons/fa';
import { BsCurrencyExchange } from 'react-icons/bs';
import { MdAddBusiness, MdDataExploration, MdOutlineTableBar, MdTabUnselected } from 'react-icons/md';
import { ImCross } from 'react-icons/im';
import { SiOpenzeppelin } from 'react-icons/si';
import { LuLayoutDashboard } from 'react-icons/lu';
import { FaUsersRays, FaCashRegister, FaMoneyBill1Wave, FaSailboat, FaGift, FaShopSlash, FaShop } from 'react-icons/fa6';
import { FaFolderOpen } from 'react-icons/fa';
import { SiContactlesspayment } from 'react-icons/si';
import { GrShift } from 'react-icons/gr';
import { GiCurlingVines } from 'react-icons/gi';

const masterList = [
  { name: 'Reports Dashboard', icon: <LuLayoutDashboard />, route: '/admin/Reports/Dashboard' },
  { name: 'Sales Detail', icon: <FaLayerGroup />, route: '/admin/Reports/ItemSale' },
  { name: 'Sale Summary Report', icon: <SiContactlesspayment />, route: '/admin/Reports/category' },
  { name: 'Cashier Sale Report', icon: <FaCashRegister />, route: '/admin/Reports/cashier' },
  { name: 'Monthly Sale Report', icon: <FaPizzaSlice />, route: '/admin/Reports/TotalSale' },
  { name: 'X Report', icon: <ImCross />, route: '/admin/Reports/XReport' },
  { name: 'Z Report', icon: <SiOpenzeppelin />, route: '/admin/Reports/ZReport' },
  // { name: 'Category Sale Report', icon: <FaFolderOpen />, route: '/admin/Reports/payment' },
  // { name: 'Orders Report', icon: <FaCog />, route: '/admin/Reports/Order' },
  // { name: 'Cash In/Out Report', icon: <FaFileUpload />, route: '/admin/Reports/Cash' },
  { name: 'Sales Tax Report', icon: <FaMoneyBillWave />, route: '/admin/Reports/SaleTax' },

  // ⭐ New tiles for your new reports:
  { name: 'Sales By Hour', icon: <BsCurrencyExchange />, route: '/admin/Reports/SalesByHour' },
  { name: 'Profit Margin Report', icon: <FaMoneyBillWave />, route: '/admin/Reports/ProfitMargin' },

  { name: 'Best & Least Sales', icon: <FaUsersRays />, route: '/admin/Reports/BestWorstSales' },
  { name: 'Daily Sales Summary', icon: <MdOutlineTableBar />, route: '/admin/Reports/DailySalesSummary' },
  { name: 'Item Expiry Report', icon: <MdDataExploration />, route: '/admin/Reports/ItemExpirySummary' },
  { name: 'Store Sales Report', icon: <MdAddBusiness />, route: '/admin/Reports/stores-sale' },
  { name: 'Purchase Tax Report', icon: <FaSellcast />, route: '/admin/Reports/PurchaseTax' },
  { name: 'Flash Sale Report', icon: <FaSailboat />, route: '/admin/Reports/FlashSummary' },
  { name: 'Gift Card Details', icon: <FaGift />, route: '/admin/Reports/GiftCardReport' },

  { name: 'Brand Sale Report', icon: <FaMoneyBillAlt />, route: '/admin/Reports/BrandSale' },

  { name: 'Store Sale Report Amount Wise', icon: <FaSellcast />, route: '/admin/Reports/AllSaleReport' },

  { name: 'Stock Report', icon: <GrShift />, route: '/admin/Reports/StockCheck' },
  { name: 'Predictive Inventory Report', icon: <FaShop />, route: '/admin/Reports/PredictiveInventory' },
];

const ReportsPage = () => {
  const navigate = useNavigate();

  const handleNavigate = (item) => {
    navigate(item);
  };

  return (
    <div className="container-fluid">
      <div className="master-grid">
        {masterList.map((item, index) => (
          <div key={index} onClick={() => handleNavigate(item.route)}>
            <div className="master-card">
              <div className="master-icon">{item.icon}</div>
              <div className="master-name">{item.name}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReportsPage;
